import { render, staticRenderFns } from "./chart-graduation.vue?vue&type=template&id=58d4d8e0&scoped=true&"
import script from "./chart-graduation.vue?vue&type=script&lang=js&"
export * from "./chart-graduation.vue?vue&type=script&lang=js&"
import style0 from "./chart-graduation.vue?vue&type=style&index=0&id=58d4d8e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d4d8e0",
  null
  
)

export default component.exports